import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { IoAdd } from "react-icons/io5";
import { IoFilter } from "react-icons/io5";
import VerticalFilterBar from "components/filter/verticalfilter";
import { useLocation } from "react-router-dom";
import { MdSearch } from "react-icons/md";
import { MdCheck } from "react-icons/md";
import { FaChartBar } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { toggleIndicator } from "store/checkboxindicatorSlice";
import { MdInfoOutline } from "react-icons/md";
import { MdOutlinePieChartOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "commonConfig/ApiConfig";
const IndicatorsList = ({
  indicatorData = [],
  filterMetaData = [],
  onIndicatorSelect,
  selectedIndicators = [],
  onFilterApply,
  sectorFilter = {},
  onShowCharts, // ✅ new
  onShowPieCharts, // ✅ new
  dataChecked = []
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [indicatorFilterData, setFilterIndicatorData] = useState([]);
  const [filteredIndicators, setFilteredIndicators] = useState([]);
  const location = useLocation();
  const isLocationPage = location.pathname === "/location";
  const isSearchList = location.pathname === "/searchlist";
  // Add this helper function to count selections for an indicator
  const getSelectionCount = (indicatorCode) => {
    return selectedIndicatorsByCheckbox.filter(
      item => item.indicator_code === indicatorCode && item.sub_indicator_code
    ).length;
  };

  const [showFilter, setShowFilter] = useState(false);
  const dispatch = useDispatch();
  // ✅ sector-based filter (only for /location)
  const applySectorFilter = (data) => {
    if (!isLocationPage) return data;

    const { sector, subSector, subSubSector } = sectorFilter || {};
    if (!sector && !subSector && !subSubSector) return data;

    return data.filter((ind) => {
      if (subSubSector?.code) return ind.sub_sub_sector_code === subSubSector.code;
      if (subSector?.code) return ind.sub_sector_code === subSector.code;
      if (sector?.code) return ind.sector_code === sector.code;
      return true;
    });
  };

  // In Indicator.js, add filter state at the top with other useState declarations:
  const [filterState, setFilterState] = useState({
    timePeriod: 'all',
    customStartYear: 2011,
    customEndYear: 2025,
    customStart: '',
    customEnd: '',
    geoLevel: [],
    selectedDatasets: [],
    selectedMinistries: []
  });

  // Base data: use filter results if applied
  const [geoFilter, setGeoFilter] = useState("ALL");
  const [appliedSearchTerm, setAppliedSearchTerm] = useState("");  // ← New state to track applied search

  useEffect(() => {
    let data = isFilterApplied ? indicatorFilterData : indicatorData;

    if (isLocationPage) {
      data = applySectorFilter(data);
    }

    if (geoFilter !== "ALL") {
      data = data.filter(ind => ind.geo_levels?.includes(geoFilter));
    }

    // Only apply search filter when appliedSearchTerm is non-empty and >=3 chars
    if (appliedSearchTerm.trim().length >= 3) {
      const search = appliedSearchTerm.trim().toLowerCase();
      data = data.filter(ind =>
        (ind.indicator_name || "").toLowerCase().includes(search)
      );
    }

    setFilteredIndicators(data);
  }, [appliedSearchTerm, geoFilter, isFilterApplied, indicatorFilterData, indicatorData, sectorFilter, isLocationPage]);

  // Called on clicking Search button
  const handleSearch = () => {
    setAppliedSearchTerm(searchTerm);
  };

  // Clear search resets appliedSearchTerm and searchTerm
  const handleClearSearch = () => {
    setSearchTerm("");
    setAppliedSearchTerm("");
    setFilteredIndicators(applySectorFilter(isFilterApplied ? indicatorFilterData : indicatorData));
  };

  // search api 
  // const handleSearch = async () => {
  //   const search = searchTerm.trim();
  //   if (!search) {
  //     setFilteredIndicators(applySectorFilter(baseData));
  //     return;
  //   }

  //   try {
  //     const response = await axios.get(
  //       `${BASE_URL}indicators/search`,
  //       {
  //         params: { q: search } 
  //       }
  //     );
  //     // assuming API returns { data: [...] }
  //     setFilteredIndicators(response.data.indicators || []);
  //   } catch (error) {
  //     console.error("Error fetching indicators:", error);
  //     setFilteredIndicators([]);
  //   }
  // };

  // Handle filters applied from VerticalFilterBar
  const handleFilterApply = (filteredData) => {
    setIsFilterApplied(true);
    setShowFilter(false);
    setFilterIndicatorData(Array.isArray(filteredData) ? filteredData : []);
    if (onFilterApply) onFilterApply(filteredData);
  };


  // state at top
  const [selectedIndicatorsByCheckbox, setSelectedIndicatorsByCheckbox] = useState([]);

  const [selectedIndicatorsBypie, setSelectedIndicatorsBypie] = useState([]);
  const [subIndicatorSelections, setSubIndicatorSelections] = useState({});

  const handleSubIndicatorChange = (indicatorCode, subIndicatorCode) => {
    setSubIndicatorSelections((prev) => ({
      ...prev,
      [indicatorCode]: subIndicatorCode,
    }));

    // Update the selectedIndicatorsByCheckbox entry
    setSelectedIndicatorsByCheckbox((prev) =>
      prev.map((item) =>
        item.indicator_code === indicatorCode
          ? { ...item, sub_indicator_code: subIndicatorCode }
          : item
      )
    );

    // Also dispatch updated version to Redux
    dispatch(toggleIndicator({
      indicator_code: indicatorCode,
      sub_indicator_code: subIndicatorCode
    }));
  };

  const handleCheckboxChange = (ind) => {
    const selectedSubCode = subIndicatorSelections[ind.indicator_code];
    const isCategorical = Array.isArray(ind.sub_indicators) && ind.sub_indicators.length > 0 && ind.sub_indicators.some(sub => sub.name && sub.name !== 'NA');

    const isSelected = selectedIndicatorsByCheckbox.some(
      item =>
        item.indicator_code === ind.indicator_code &&
        (!isCategorical || item.sub_indicator_code === selectedSubCode)
    );

    if (isSelected) {
      // ✅ Remove all related entries (including sub indicators)
      setSelectedIndicatorsByCheckbox((prev) =>
        prev.filter(item => item.indicator_code !== ind.indicator_code)
      );

      // ✅ Clear any sub indicator selections
      setSubIndicatorSelections((prev) => {
        const updated = { ...prev };
        delete updated[ind.indicator_code];
        return updated;
      });

      // ✅ Update Redux
      dispatch(toggleIndicator(ind));
    } else {
      // ✅ Add new indicator
      setSelectedIndicatorsByCheckbox((prev) => [...prev, ind]);
      dispatch(toggleIndicator(ind));
    }
  };

  useEffect(() => {
    if (Array.isArray(dataChecked) && dataChecked.length > 0) {
      setSelectedIndicatorsByCheckbox(dataChecked);

      // Also populate subIndicatorSelections for Categorical indicators
      const subSelections = {};
      dataChecked.forEach((item) => {
        if (Array.isArray(item.sub_indicators) && item.sub_indicators.length > 0 && item.sub_indicators.some(sub => sub.name && sub.name !== 'NA')) {
          subSelections[item.indicator_code] = item.sub_indicator_code;
        }
      });
      setSubIndicatorSelections(subSelections);
    }
  }, [dataChecked]);


  return (
    <div className=" ui-box-v1">
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className=" d-flex col-md-12">
              <h5 className="mb-2">Indicators Listing  <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="indicator-tooltip">
                    <p>All the indicators available for Geographic unit' are listed below. You can filter lower units through the buttons below or use the search bar or filter options. Tick to add indicators to your workspace to visualise (see workspace pop out on the right hand side) or make a quick chart using the 'chart' button</p>
                  </Tooltip>
                }
              >
                <span>
                  <MdInfoOutline style={{ cursor: "pointer", color: "#000000" }} />
                </span>
              </OverlayTrigger></h5>
              {isSearchList && (
                <div className="ms-3">
                <Button
                        variant="outline-primary"
                        onClick={() => setShowFilter((prev) => !prev)}
                        className="rounded-pill me-2 mb-1"
                      >
                        <IoFilter /> &nbsp; Filter
                      </Button>
                      </div>
              )}  
              
            </div>
                        
            {isLocationPage && (
              <>
                <div className="d-flex mb-2">
                  <div className="p-1">
                    <button
                      className={`btn btn-outline-primary ${geoFilter === "ALL" ? "active" : ""}`}
                      onClick={() => setGeoFilter("ALL")}
                    >
                      All Geographic Granularities
                    </button>
                  </div>
                  <div className="p-1">
                    <button
                      className={`btn btn-outline-primary ${geoFilter === "National" ? "active" : ""}`}
                      onClick={() => setGeoFilter("National")}
                    >
                      National
                    </button>
                  </div>
                  <div className="p-1">
                    <button
                      className={`btn btn-outline-primary ${geoFilter === "State" ? "active" : ""}`}
                      onClick={() => setGeoFilter("State")}
                    >
                      State
                    </button>
                  </div>
                  <div className="p-1">
                    <button
                      className={`btn btn-outline-primary ${geoFilter === "District" ? "active" : ""}`}
                      onClick={() => setGeoFilter("District")}
                    >
                      District
                    </button>
                  </div>
                  <div className="p-1">
                    <button
                      className={`btn btn-outline-primary ${geoFilter === "ULG" ? "active" : ""}`}
                      onClick={() => setGeoFilter("ULG")}
                    >
                      ULG
                    </button>
                  </div>

                </div>

              </>
            )}
            {!isSearchList && (
              <>
                <div className={isLocationPage ? "col-md-5" : "col-md-6"}>
                  <input
                    type="text"
                    className="form-control mb-3"
                    placeholder="Search indicators..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                <div className={isLocationPage ? "col-md-7" : "col-md-4"}>
                  <div className="d-flex">
                    <Button
                      variant="outline-secondary"
                      className="rounded-pill me-2 mb-1"
                      onClick={() => {
                        setSearchTerm("");
                        setAppliedSearchTerm("");
                        setFilteredIndicators(applySectorFilter(isFilterApplied ? indicatorFilterData : indicatorData));
                      }}
                    >
                      Clear
                    </Button>
                    <Button
                      disabled={searchTerm.trim().length < 3}
                      variant="outline-primary"
                      className="rounded-pill me-2 mb-1"
                      onClick={handleSearch}
                    >
                      <MdSearch /> &nbsp; Search
                    </Button>
                      <Button
                        variant="outline-primary"
                        onClick={() => setShowFilter((prev) => !prev)}
                        className="rounded-pill me-2 mb-1"
                      >
                        <IoFilter /> &nbsp; Filter
                      </Button>
                  </div>
                </div>
              </>
            )}

          </div>
        </div>

        {/* Filters */}
        <div className={isLocationPage ? "col-md-12" : "col-md-3"}>
          {( showFilter) && <VerticalFilterBar
            indicatorData={indicatorData}
            filterMetaData={filterMetaData}
            onFilterApply={handleFilterApply}
            filterState={filterState}
            setFilterState={setFilterState}
          />}
        </div>

        {/* Indicator list */}
        <div className={isLocationPage ? "col-md-12" : (showFilter?"col-md-9":"col-md-12")}>
          {/* <div className="text-end px-10">
            {isLocationPage && (
              <Button
                variant="outline-primary"
                //onClick={() => setShowChart((prev) => !prev)}
                onClick={() => onShowCharts(selectedIndicatorsByCheckbox)}
                disabled={selectedIndicatorsByCheckbox.length === 0}
                className="rounded-pill me-2 mb-1"
              >
                <FaChartBar /> &nbsp; Chart
              </Button>
            )}
          </div> */}
          <table className="table  indicator-table">
            <tbody>
              {filteredIndicators.length === 0 ? (
                <tr>
                  <td
                    colSpan={isLocationPage ? 4 : 3}
                    className="text-muted text-center"
                  >
                    No indicators found
                  </td>
                </tr>
              ) : (
                filteredIndicators.map((ind, index) => {
                  const isSelected = selectedIndicators.some(
                    (sel) => sel.indicator_code === ind.indicator_code
                  );
                  return (
                    <tr
                      key={ind.indicator_code || index}
                      className="cursor-pointer"
                    // onClick={() => onIndicatorSelect(ind)}
                    >
                      {/* Serial Number */}
                      <td style={{ width: "50px" }}>
                        <span className="badge bg-secondary">{index + 1}</span>
                      </td>

                      {/* Indicator Details */}
                      <td>
                        {/* {ind.indicator_name && (
                          <strong className="color-dark-blue f-14">
{[
    ind.indicator_name
      ? `${ind.indicator_name} (${ind.dataset_name || ""})`
      : "",
    ind.indicator_date ? (
      <span
        key="date"
        style={{
          backgroundColor: "#2c7ce5", // dark background
          color: "#fff",              // white text
          borderRadius: "0.25rem",    // rounded edges
          padding: "0.2rem 0.4rem",   // optional padding for better look
        }}
      >
        {ind.indicator_date}
      </span>
    ) : "",
    ind.agency_name || "",
    ind.geo_level_string || "",
  ]
                              .filter((val) => val && val !== "NA")
                              .join(" | ")}
                          </strong>
                        )} */}
               
  {ind.indicator_name && (
    <strong className="color-dark-blue f-14">
      <>
        {ind.indicator_name && (
          <>
            {ind.indicator_name}
            {ind.dataset_name ? ` (${ind.dataset_name})` : ""}
          </>
        )}

        {ind.indicator_date && (
          <>
            {" | "}
            <span
              style={{
                backgroundColor: "#2c7ce5",
                color: "#fff",
                borderRadius: "0.25rem",
                padding: "0.2rem 0.4rem",
              }}
            >
              {ind.indicator_date}
            </span>
          </>
        )}

        {ind.agency_name && <>{" | "}{ind.agency_name}</>}
      </>
    </strong>
  )}

  {/* Available Geo Levels Section */}
  {ind.geo_levels && ind.geo_levels.length > 0 && (
    <div className="mt-1 mb-1">
      <span className="me-2" style={{ fontSize: "0.875rem" }}>Available Geographic Levels:</span>
      {ind.geo_levels.map((level, idx) => (
        <span
          key={idx}
          style={{
            backgroundColor: "#28a745",
            color: "#fff",
            borderRadius: "0.25rem",
            padding: "0.2rem 0.5rem",
            marginRight: "0.3rem",
            fontSize: "0.75rem",
            display: "inline-block"
          }}
        >
          {level}
        </span>
      ))}
    </div>
  )}

  <p className="small f-12 mb-0">
    {[ind.sector_name, ind.sub_sector_name, ind.sub_sub_sector_name]
      .filter((val) => val && val !== "NA")
      .join(" | ")}
  </p>
</td>
       
                      {/* {isLocationPage && ind.unit?.toLowerCase() == "text" && (<td style={{ width: "60px" }}></td>)}
                      {isLocationPage && ind.unit?.toLowerCase() !== "text" && (
                        <td style={{ width: "200px" }}>
                          <div className="d-flex flex-column">
                            <input
                              type="checkbox"
                              checked={dataChecked.some(
                                item =>
                                  item.indicator_code === ind.indicator_code

                              )}
                              onChange={() => handleCheckboxChange(ind)}
                            />

                            {/* Show dropdown only when checked and measurement_type is Categorical - Nominal *  /   }
                            {Array.isArray(ind.sub_indicators) && ind.sub_indicators.length > 0 && ind.sub_indicators.some(sub => sub.name && sub.name !== 'NA') &&
                              selectedIndicatorsByCheckbox.some(
                                item => item.indicator_code === ind.indicator_code
                              ) && (
                                <select
                                  className="form-select mt-2"
                                  value={subIndicatorSelections[ind.indicator_code] || ""}
                                  onChange={(e) =>
                                    handleSubIndicatorChange(ind.indicator_code, e.target.value)
                                  }
                                >
                                  <option value="">
                                    {getSelectionCount(ind.indicator_code) > 0
                                      ? `Selected: ${getSelectionCount(ind.indicator_code)}`
                                      : "Select"}
                                  </option>
                                  {ind.sub_indicators?.map((sub) => {
                                    const isSelected = selectedIndicatorsByCheckbox.some(
                                      item => item.indicator_code === ind.indicator_code &&
                                        item.sub_indicator_code === sub.code
                                    );
                                    return (
                                      <option
                                        key={sub.code}
                                        value={sub.code}
                                        style={isSelected ? {
                                          backgroundColor: '#e3f2fd',
                                          fontWeight: 'bold'
                                        } : {}}
                                      >
                                        {isSelected ? '✓ ' : ''}{sub.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              )}
                          </div>
                        </td>
                      )} */}


                      {/* Action Button */}
                      <td style={{ width: "70px" }}>
                        <Button
                          variant="falcon-primary"
                          size="sm"
                          disabled={isSelected}
                          title="Add Indicator to Workspace to Analyse / Visualise"
                          onClick={(e) => {
                            e.stopPropagation();
                            onIndicatorSelect(ind);
                          }}
                        >
                          {isSelected ? <MdCheck /> : <IoAdd />}
                        </Button>
                      </td>
                      {/* {isLocationPage &&Array.isArray(ind.sub_indicators) && ind.sub_indicators.length > 0 && ind.sub_indicators.some(sub => sub.name && sub.name !== 'NA') && (
                        <td>
                          <button
                            className="btn  btn-outline-primary"
                            onClick={() => onShowPieCharts(ind)
                            }
                          >
                            <MdOutlinePieChartOutline
                              style={{ width: "20px", height: "20px", cursor: "pointer" }} />
                          </button>
                        </td>
                      )}{isLocationPage && Array.isArray(ind.sub_indicators) && ind.sub_indicators.length > 0 && ind.sub_indicators.some(sub => sub.name && sub.name !== 'NA') && (
                        <td>
                          {/* <button
                            className="btn  btn-outline-primary"
                            onClick={() => onShowPieCharts(ind)
                            }
                          >
                            <MdOutlinePieChartOutline
                              style={{ width: "20px", height: "20px", cursor: "pointer" }} />
                          </button> * / }
                        </td>
                      )} */}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>

        </div>
      </div>
    </div>
  );
};

export default IndicatorsList;
